import { Button, Group } from "@mantine/core";
import { SecondaryButton } from "./buttons";
import { PANEL_LAYOUT } from "./tokens";

/**
 * A form's closing row (Figma Brand Configuration): Cancel (outlined) and the committing
 * button (filled), 200px each, at the right end, 5px apart.
 */
export function FormButtons({
  submitLabel,
  onSubmit,
  onCancel,
  submitting,
  submitDisabled,
  cancelDisabled,
}: {
  submitLabel: string;
  onSubmit: () => void;
  onCancel: () => void;
  submitting?: boolean;
  submitDisabled?: boolean;
  cancelDisabled?: boolean;
}) {
  return (
    <Group justify="flex-end" gap={5}>
      <SecondaryButton w={PANEL_LAYOUT.formButtonWidth} onClick={onCancel} disabled={cancelDisabled}>
        Cancel
      </SecondaryButton>
      <Button w={PANEL_LAYOUT.formButtonWidth} loading={submitting} disabled={submitDisabled} onClick={onSubmit}>
        {submitLabel}
      </Button>
    </Group>
  );
}
